var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-own-carousel",style:({
    '--size': ("calc((var(--default-size) - var(--gap) * " + (_vm.cCount > 1 ? _vm.cCount - 1 : 1) + ") / " + _vm.cCount + ")"),
    '--gap': ("" + _vm.gap),
    '--template': "var(--size)"
  }),on:{"mouseenter":_vm.mouseenter,"mouseleave":_vm.mouseleave}},[_c('div',{staticClass:"slides-wrapper"},[_c('div',{staticClass:"slides",style:({
        transform: ("translate3d(calc((var(--size) * " + _vm.current + " + (var(--gap) * " + _vm.current + ")) * -1),0,0)")
      })},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }